import { DrawerHeader, DrawerHeaderTitle, DrawerBody, DrawerFooter, Button, Input, Label, tokens, OverlayDrawer, Body1Strong, Checkbox, Radio, RadioGroup, Subtitle2, InfoLabel } from "@fluentui/react-components";
import { BranchFilled, Dismiss24Regular } from "@fluentui/react-icons";
import { useCallback, useState } from "react";

export default function NewBranchDrawer(
    {
        open,
        setOpen,
        createBranchCallback
    }: {
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        createBranchCallback: (
            name: string
        ) => void
    }
) {
    const [ branchName, setBranchName ] = useState("");

    const createBranch = useCallback(
        () => {
            createBranchCallback( branchName );
            setOpen(false);
        },
        []
    );

    return (
        <>
            <OverlayDrawer modalType="modal" open={open} onOpenChange={( _, d ) => setOpen(d.open)} size="medium" position="end">
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="close"
                                icon={<Dismiss24Regular />}
                                onClick={() => setOpen(false)}
                            />
                        }>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <BranchFilled /> New Branch
                        </div>
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody>
                    <Label htmlFor="new-branch-dialog-input" style={{ fontWeight: tokens.fontWeightSemibold }}>Name</Label>
                    <Input placeholder="Name" type="text" style={{ width: "100%" }} id="new-branch-dialog-input" defaultValue="ExampleBranch" />
                    
                    <div style={{ marginTop: "1rem" }}>
                        <Subtitle2>
                            Access Control
                        </Subtitle2>
                        
                        <div style={{ marginTop: "0.5rem" }}>
                            <Checkbox id="new-branch-public-access" label={
                                <InfoLabel htmlFor="new-branch-public-access"
                                           label="Allow public access to this branch"
                                           info={
                                            <div>
                                                This branch will be accessible to all unauthenticated clients. Default branches cannot be private.
                                            </div>
                                           } />
                            } defaultChecked={true} />
                        </div>

                        <div style={{ marginTop: "0.5rem" }}>
                            <Body1Strong>Restrict access to:</Body1Strong>
                            <RadioGroup disabled>
                                <Radio label="All users of [DOMAIN_NAME]" defaultChecked={true} />
                                <Radio label="Specific user groups in [DOMAIN_NAME]" />
                                <Radio label="Specific users of [DOMAIN_NAME]" />
                            </RadioGroup>
                        </div>
                    </div>
                </DrawerBody>
                <DrawerFooter>
                    <Button appearance="primary" onClick={createBranch}>
                        Create
                    </Button>
                </DrawerFooter>
            </OverlayDrawer>
        </>
    );
}